<template>
    <div>
        <van-nav-bar title='天气预报'  @click-left="back" left-arrow/>
		<div style="position:absolute;top:46px;left:0;right:0;bottom:0;overflow:auto;background:#ededed">
			<van-cell-group title="未来24小时预报" />
			<div class='antV_charts' style="width:100%;overflow-x:auto;-webkit-overflow-scrolling: touch;">
       			<canvas id="charts_hous" style="width:300%;height:250px"></canvas>
     		</div>
			<van-cell-group title="未来7天预报" />
			<div class='antV_charts' style="width:100%">
       			<canvas id="charts_day" style="width:100%;height:250px"></canvas>
     		</div>
			<van-cell-group title="未来7天降雨预报" />	
			<div class='antV_charts' style="width:100%">
       			<canvas id="charts_rday" style="width:100%;height:250px"></canvas>
     		</div>		
		</div>
    </div>
</template>

<script>
import F2 from "@antv/f2/lib/index-all";
const Tooltip = require('@antv/f2/lib/plugin/tooltip');
export default {
    name:'forecast',
    data() {
        return {
            futrue_hous:[],
		    futrue_day:[],
            futrue_rday:[],
            weatherArr:[],
            oneDat:[]
        }
    },
    mounted() {
        console.log(this.$route.params.weatherArr)
       this.weatherArr =  this.$route.params.weatherArr
       this.weatherChart()
    },
    methods: {
        weatherChart(){            
            this.$toast({
                type:'loading',
                mask:true,
                forbidClick:true,
                duration:0
            }); 
            
            this.futrue_hous = []
            this.futrue_day = []
            this.futrue_rday = []
            //24小时预报
            for (let i = 0; i < this.weatherArr.forecast24.time.length; i++) {
                let data = {}
                data.time = this.weatherArr.forecast24.time[i].substr(0,2)
                data.value = this.weatherArr.forecast24.tem[i]
                data.state = this.weatherArr.forecast24.weather_info[i]

                this.oneDat.push(this.weatherArr.forecast24.time[i].substr(0,2))
                this.futrue_hous.push(data)
            }
            //7天预报
            for (let i = 0; i < this.weatherArr.forecast7.max_tem.length; i++) {
                let time = this.getDay(i)			
                let data1  ={}
                data1.tem = this.weatherArr.forecast7.max_tem[i]
                data1.state = this.weatherArr.forecast7.weather_info[i]
                data1.time = time.time+'\n'+time.week
                // data1.week = time.week
                data1.name = '最大值'
                this.futrue_day.push(data1)
                
                let data2 ={}
                data2.tem = this.weatherArr.forecast7.min_tem[i]
                data2.state = this.weatherArr.forecast7.weather_info[i]
                data2.time = time.time+'\n'+time.week
                // data2.week = time.week
                data2.name = '最小值'
                this.futrue_day.push(data2)
            }
            //7天降雨预报
            for (let i = 0; i < this.weatherArr.rain.length; i++) {
                let data = {}
                let time = this.getDay(i)
                data.value = this.weatherArr.rain[i]			
                data.time = time.time+'\n'+time.week                
                this.futrue_rday.push(data)
            }
            
            this.addHous()
            this.addDay()
            this.addRDay()
            this.$toast.clear()
        },
        addHous(){
            let _that = this
            let chart = new F2.Chart({
                id: 'charts_hous',
                pixelRatio: window.devicePixelRatio
            });
            chart.source(this.futrue_hous, {
                value: {
                    tickCount: 6,
                    min: 0
                },
                time:{
                    formatter: function formatter(val) {                        
                        return val+'时';
                    }
                }            
            });
            chart.tooltip(false)            

 
            this.futrue_hous.map(function(obj) {
                chart.guide().text({
                position: [obj.time, obj.value],
                direct:'tc',
                offsetY:-5,
                content: obj.value+'℃\n'+obj.state,
                style: {
                    textBaseline: 'bottom',
                    textAlign: 'center'
                },
                
                });
            });
           

            chart.line().position('time*value');
            chart.point().position('time*value').style({
                stroke: '#fff',
                lineWidth: 1
            });
            chart.render();
        },
        addDay(){
            let chart = new F2.Chart({
                id: 'charts_day',
                pixelRatio: window.devicePixelRatio
            });
            chart.source(this.futrue_day,{
                time:{
                    formatter: function formatter(val) {                        
                        return val+'\n';
                    }
                }
            });    
            chart.tooltip(false)
            this.futrue_day.map(function(obj) {
                chart.guide().text({
                position: [obj.time, obj.tem],
                content: obj.tem+'℃',
                style: {
                    textBaseline: 'bottom',
                    textAlign: 'center'
                },
                offsetY: -2
                });
            });
            
            chart.line().position('time*tem').color('name');
            chart.point().position('time*tem').style({
                stroke: '#fff',
                lineWidth: 1
            });
            chart.render();

        },
        addRDay(){
             let _that = this
            let chart = new F2.Chart({
                id: 'charts_rday',
                pixelRatio: window.devicePixelRatio
            });
            chart.source(this.futrue_rday, {                
                time:{
                    formatter: function formatter(val) {                        
                        return val;
                    }
                }            
            });
            chart.tooltip(false)
            chart.axis('time',{
                top: true
            })
 
            this.futrue_rday.map(function(obj) {
                chart.guide().text({
                position: [obj.time, obj.value],
                direct:'tc',
                offsetY:-5,
                content: obj.value+'mm',
                style: {
                    textBaseline: 'bottom',
                    textAlign: 'center'
                },
                
                });
            });
           

            chart.line().position('time*value');
            chart.point().position('time*value').style({
                stroke: '#fff',
                lineWidth: 1
            });
            chart.render();

        },
        getDay(day){
            let today = new Date();
            let targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
            // let tYear = today.getFullYear();
            let tMonth = today.getMonth();
            let tDate = today.getDate();
            tMonth = this.doHandleMonth(tMonth + 1);
            tDate = this.doHandleMonth(tDate);
            let weekDayArr=["星期日","星期一","星期二","星期三","星期四","星期五","星期六"]//星期映射数组
            var weekDay=today.getDay();
            let data = {}
            data.time = tMonth+"/"+tDate
            data.week = weekDayArr[weekDay]
            return data;
        },
        doHandleMonth(month){
            let m = month;
            if(month.toString().length == 1){
             m = "0" + month;
            }
            return m;
        },
        back(){
            this.$router.go(-1)
        }
    },
}
</script>

<style  scoped>

</style>